module.exports = __webpack_public_path__ + "static/media/icon-qrcode.a060b09c.svg";